import asyncComponentLoader from '@/shared/lib/loader';

import { ROUTES } from './paths';
import { mediaPlansRoutes } from './shared';
import { ordersRoutes } from './shared';
import { PageRoute } from './types';

export const locationRoutes: PageRoute[] = [
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/StatisticsPage')),
    path: `${ROUTES.AUTHORIZED.STATISTICS}/:id?`,
    title: 'Statistics',
  },
  {
    component: asyncComponentLoader(() => import('@/features/shell/pages/MockStatisticsPage')),
    path: ROUTES.AUTHORIZED.STATISTICS_MOCK,
    title: 'Statistics (Mock)',
  },
  ...mediaPlansRoutes,
  {
    component: asyncComponentLoader(
      () => import('@/features/spaces/pages/AdvertisingSpaceFormPage'),
    ),
    path: `${ROUTES.AUTHORIZED.ADVERTISING_SPACE_FORM}/:id?`,
    title: 'Add New Advertising Space',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/spaces/pages/AdvertisingSpaceRemovePage'),
    ),
    path: `${ROUTES.AUTHORIZED.DELETE_ADVERTISING_SPACE}/:id`,
    title: 'Remove Advertising Space',
  },
  ...ordersRoutes,
  {
    component: asyncComponentLoader(
      () =>
        import('@/features/packages/pages/AdvertisingPackageFormPage/AdvertisingPackageFormPage'),
    ),
    path: `${ROUTES.AUTHORIZED.ADVERTISING_PACKAGES_FORM}/:id?`,
    title: 'Advertising Package Form',
  },
  {
    component: asyncComponentLoader(
      () => import('@/features/packages/pages/AdvertisingPackageDeletePage'),
    ),
    path: `${ROUTES.AUTHORIZED.ADVERTISING_PACKAGES_DELETE}/:id`,
    title: 'Delete Advertising Package',
  },
];
